<div>
  <span class="status">{{cell?.row?.status | titlecase}}</span>
  <span class="status" *ngIf="cell?.row?.CT"> - {{cell?.row?.CT | parseDate | date: 'dd MMM yyyy' }}</span>
</div>
